'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var sellerCategoryComponent = exports.sellerCategoryComponent = {
    template: require('./sellercategory.html'),
    bindings: {
        sellerCategory: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$state", "$stateParams", "productOverviewService", "Enums", "common", function controller($scope, $state, $stateParams, productOverviewService, Enums, common) {
        'ngInject';

        var vm = this;
        vm.productOverviewModel = null;
        vm.$onInit = init;

        var categoryId = parseInt($stateParams.categoryId);

        function init() {
            common.navigationMenu.setSellersActive();
            common.setTitle(vm.sellerCategory.categories[vm.sellerCategory.categories.length - 1].name);

            vm.productOverviewModel = productOverviewService.init(Enums.searchContext.seller.id);
            productOverviewService.getProductsBySellerCategory(true, vm.productOverviewModel, vm.sellerCategory.id, categoryId).then(function (model) {
                vm.productOverviewModel = model;
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                productOverviewService.getProductsBySellerCategory(false, vm.productOverviewModel, vm.sellerCategory.id, categoryId).then(function (model) {
                    vm.productOverviewModel = model;
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                }).catch(function () {
                    $state.go('error', {}, {
                        location: false
                    });
                });
            });
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/seller/sellercategory.js
// module id = 1030
// module chunks = 0